import { Emblem } from "./Emblem";

const BOLTS = ["M14 22 L22 36 L15 38 L25 52", "M86 18 L78 32 L85 34 L74 50", "M90 70 L82 78 L88 81 L79 92", "M8 66 L15 74 L9 77 L17 88"];

export const AnimatedEmblem = ({ className = "h-28 w-28", testid = "animated-emblem" }) => (
  <div className={`relative group ${className}`} data-testid={testid}>
    <div className="emblem-flash-glow absolute inset-[-18%] rounded-full pointer-events-none" />
    <Emblem className="emblem-intro relative h-full w-full" />
    <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full pointer-events-none overflow-visible" aria-hidden>
      <defs>
        <linearGradient id="ring-sheen" x1="0" x2="1">
          <stop offset="0" stopColor="#C9B6F2" stopOpacity="0" />
          <stop offset=".5" stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#F2C230" stopOpacity="0" />
        </linearGradient>
      </defs>
      <g transform="translate(0 1.28) scale(0.934)">
      <ellipse cx="50" cy="60" rx="47" ry="17" transform="rotate(-16 50 60)" pathLength="100"
        fill="none" stroke="url(#ring-sheen)" strokeWidth="3.2" strokeLinecap="round" className="ring-spin" />
      {BOLTS.map((d, i) => (
        <path key={d} d={d} fill="none" stroke="#FFF3B0" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round"
          className="bolt-flash" style={{ animationDelay: `${0.55 + i * 0.12}s` }} />
      ))}
      </g>
    </svg>
  </div>
);
